import * as React from 'react';
import * as program from "./style.module.scss";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material';
import { programData } from "./programData";

const StyledAccordion = styled(Accordion)({
  boxShadow: "unset",
  backgroundColor: "unset",
  marginBottom: "26px",
  "&:last-child": {
    marginBottom: 0,
  },
  "&::before": {
    display: "none",
  },
  "@media (max-width: 767px)": {
    marginBottom: "16px",
  },
});

const StyledSummary = styled(AccordionSummary)({
  position: "relative",
  cursor: "pointer",
  borderBottom: ".5px solid #000",
  textAlign: "left",
  outline: "none",
  fontSize: "32px",
  lineHeight: "130%",
  fontWeight: "700",
  transition: "0.4s",
  width: "100%",
  padding: "0 0 26px 0",
  "&:after": {
    content: "''",
    position: "absolute",
    backgroundImage: `url("https://fs.advance.ru/landing-pages/course/kurs-razvitiya-pamyaty/prog-plus.svg")`,
    backgroundRepeat: "no-repeat",
    top: 0,
    right: 0,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 767px)": {
      backgroundSize: "70%",
    },
  },
  "&.Mui-expanded": {
    borderBottom: ".5px solid #fff",
    "&:after": {
      backgroundImage: `url("https://fs.advance.ru/landing-pages/course/kurs-razvitiya-pamyaty/prog-minus.svg")`,
    }
  },
  ".MuiAccordionSummary-content": {
    margin: 0,
    paddingRight: "45px",
    display: "flex",
    flexDirection: "column",
  },
  "@media (max-width: 991px)": {
    fontSize: "20px",
    padding: "0 0 16px 0",
  },
});

const StyledDetails = styled(AccordionDetails)({
  backgroundColor: '#fff',
  overflow: "hidden",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "21px",
  padding: "10px 0 10px 0",
  borderBottom: ".5px solid #000",
  "@media (max-width: 767px)": {
    fontSize: "15px",
    lineHeight: "17px",
  },
});

export const Program = ({ data=programData }) => {
  return (
    <section className={`${program.program} container`} id="program">
      <h2 className={program.program__title}>Программа курса</h2>
      <div className={program.program__list}>
        {data.map((elem, index) => (
          <StyledAccordion disableGutters={true} key={index} square>
            <StyledSummary>
              {elem.title}
            </StyledSummary>
            <StyledDetails>
              {elem.description}
            </StyledDetails>
          </StyledAccordion>
        ))}
      </div>
    </section>
  );
};
